





















































































































import { Component } from "vue-property-decorator";
import { CreditVueGB } from "@/extensions/contract/CreditVueGB";
import Requisites from "@/components/contracts/Requisites.vue";
import ContractDetails from "@/components/contracts/ContractDetails.vue";
import BackLink from "@/components/app/BackLink.vue";
import ScheduleModal from "@/components/contracts/ScheduleModal.vue";
import CreditRequest from "@/components/contracts/CreditRequest.vue";

@Component({
  components: {
    BackLink,
    ContractDetails,
    Requisites,
    ScheduleModal,
    CreditRequest
  }
})
export default class Credit extends CreditVueGB {
}
